import { style } from '@vanilla-extract/css'
import { vars } from '../design/theme.css'

// The collage's bird nodes are clickable (open the species modal).
export const bird = style({ cursor: 'pointer' })

// The line drawn across an empty collage. It lives here rather than on the <text> element's own
// attributes, where its size was a bare 30 and its colour a `var(--ink-soft, #8b8b91)` carrying
// a fallback from a palette the station no longer has.
export const emptyMark = style({
  fontFamily: vars.font.serif,
  fontStyle: 'italic',
  fontSize: vars.fs['2xl'],
  fill: vars.color.inkSoft,
})
